module.exports = __webpack_public_path__ + "img/3.00ac0371.png";